import clsx from 'clsx';

import type { BaseDecorativeProps } from './types';

import {
  decorativeBarContainer,
  decorativeColorBar,
  decorativeColorContainer,
  decorativeColorKind,
} from './styles.css';

export type DecorativeColorKind = 'default' | 'primary' | 'error';

export interface DecorativeColorProps extends BaseDecorativeProps {
  /**
   * The kind/color of the bar.
   * - 'default': Grey
   * - 'primary': Blue
   * - 'error': Red
   * @default 'default'
   */
  kind?: DecorativeColorKind;
}

/**
 * A colored bar used as a visual indicator in table cells.
 * The bar is always 16px tall and centered vertically within its container.
 * The height is determined by the parent Cell's size.
 *
 * @example
 * ```tsx
 * // Default (grey) indicator
 * <DecorativeColor />
 *
 * // Error (red) indicator
 * <DecorativeColor kind="error" />
 *
 * // Primary (blue) indicator
 * <DecorativeColor kind="primary" />
 * ```
 */
export const DecorativeColor = ({ kind = 'default', className }: DecorativeColorProps) => {
  return (
    <div className={clsx(decorativeColorContainer, className)}>
      <div className={decorativeBarContainer}>
        <div className={clsx(decorativeColorBar, decorativeColorKind[kind])} />
      </div>
    </div>
  );
};
